module.exports = __webpack_public_path__ + "static/img/tup8.706bff1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/common/tup8.png
// module id = p+vA
// module chunks = 0